import { render, staticRenderFns } from "./verifySportDetail.vue?vue&type=template&id=054c228c&scoped=true"
import script from "./verifySportDetail.vue?vue&type=script&lang=js"
export * from "./verifySportDetail.vue?vue&type=script&lang=js"
import style0 from "./verifySportDetail.vue?vue&type=style&index=0&id=054c228c&prod&lang=less&scoped=true"
import style1 from "./verifySportDetail.vue?vue&type=style&index=1&id=054c228c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c228c",
  null
  
)

export default component.exports